import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/app/apps/client/app/ClientProviders.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/app/apps/client/app/Scripts.tsx");
;
import(/* webpackMode: "eager" */ "/www/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/www/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Source_Code_Pro\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"700\"],\"display\":\"swap\",\"variable\":\"--font-source-code-pro\"}],\"variableName\":\"sourceCodePro\"}");
;
import(/* webpackMode: "eager" */ "/www/app/apps/client/src/styles/reset.css");
